const typeSpeed = 150;
const drawerWidth = 240;
const serviceID = 'service_jjcha0p';
const templateID = 'template_eco4z1r';
const userID = 'user_Tyqvr5ZSCefJW9q69Y1SO';
export {typeSpeed, drawerWidth, serviceID, templateID, userID};